import { render, staticRenderFns } from "./AdminChatBase.vue?vue&type=template&id=3a02626c"
import script from "./AdminChatBase.vue?vue&type=script&lang=js"
export * from "./AdminChatBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports